export const DYDX_LCD_URL = 'https://lcd-dydx.cosmostation.io';
